import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect } from 'react';
var css = {
  "playerWrapper": "oalp-3HJZ9",
  "videoOverlay": "oalp-mtYU7",
  "titleSection": "oalp-VsWf_",
  "portrait": "oalp-Wgp-a",
  "cta": "oalp-2O6F8",
  "ctaWithText": "oalp-u0zSO",
  "landscape": "oalp-2gxYP",
  "ctaText": "oalp-3xvza",
  "benefits": "oalp-yfvGN"
};
import classNames from 'classnames';
import { Icon } from 'panamera-react-ui';
import CTA from "../../Components/CTA/CTA";
import { TRACKING_EVENTS } from "../../Constants/trackingEvents";
import { INTENTS, SELECT_FROM } from "../../Constants/video";
export var VideoOverlay = function VideoOverlay(_ref) {
  var title = _ref.title,
    crossIcon = _ref.crossIcon,
    handleCrossButton = _ref.handleCrossButton,
    ctaWithText = _ref.ctaWithText,
    widgetKey = _ref.name,
    isPlaying = _ref.isPlaying,
    cta = _ref.cta,
    track = _ref.track,
    handleCtaClick = _ref.handleCtaClick;
  var _ref2 = crossIcon || {},
    name = _ref2.name,
    size = _ref2.size,
    color = _ref2.color;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLandscapeMode = _useState2[0],
    setLandscapeMode = _useState2[1];
  useEffect(function () {
    window.addEventListener('orientationchange', function () {
      switch (window.orientation) {
        case -90:
        case 90:
          setLandscapeMode(true);
          break;
        default:
          setLandscapeMode(false);
          break;
      }
    });
  });
  function handleOnClick() {
    if (track && (cta || ctaWithText)) {
      var trackingInfo = {
        select_from: isLandscapeMode ? SELECT_FROM.LANDSCAPE : SELECT_FROM.PORTRAIT,
        intents: isPlaying ? INTENTS.PLAY : INTENTS.PAUSE
      };
      if (isLandscapeMode && isPlaying) {
        trackingInfo.chosen_option = cta ? cta.name : '';
      } else {
        trackingInfo.chosen_option = ctaWithText && ctaWithText.button ? ctaWithText.button.name : '';
      }
      track(TRACKING_EVENTS.VIDEO_REDIRECTION_CTA_TAP, trackingInfo);
      handleCtaClick();
    }
  }
  var getCTA = function getCTA() {
    var fullCTA = /*#__PURE__*/React.createElement(React.Fragment, null, ctaWithText && /*#__PURE__*/React.createElement("div", {
      style: ctaWithText.style,
      className: classNames(css.cta, css.ctaWithText, _defineProperty({}, css.landscape, isLandscapeMode))
    }, /*#__PURE__*/React.createElement("div", {
      className: css.ctaText
    }, ctaWithText.text), /*#__PURE__*/React.createElement(CTA, {
      button: ctaWithText.button,
      handleOnClick: handleOnClick,
      widgetKey: widgetKey
    })));
    if (isLandscapeMode) {
      return cta && isPlaying ? /*#__PURE__*/React.createElement("div", {
        className: classNames(css.cta, css.landscape)
      }, /*#__PURE__*/React.createElement(CTA, {
        button: cta,
        handleOnClick: handleOnClick,
        widgetKey: widgetKey
      })) : fullCTA;
    }
    return fullCTA;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: css.videoOverlay
  }, title && /*#__PURE__*/React.createElement("div", {
    className: classNames(css.titleSection, _defineProperty({}, css.portrait, !isLandscapeMode))
  }, /*#__PURE__*/React.createElement("div", {
    style: title.style
  }, title.text), crossIcon && /*#__PURE__*/React.createElement("span", {
    onClick: handleCrossButton,
    className: css.crossButton
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: name,
    size: size,
    color: color
  }))), getCTA());
};
export default VideoOverlay;